import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

function Fraud() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCase, setSelectedCase] = useState(null);
  const [fraudCases, setFraudCases] = useState([]);
  const [loading, setLoading] = useState(true);

  // Load fraud cases from API
  useEffect(() => {
    const fetchFraudCases = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_URL}/fraud-cases`);
        if (response.ok) {
          const data = await response.json();
          setFraudCases(data);
        } else {
          console.error('Failed to fetch fraud cases');
        }
      } catch (error) {
        console.error('Error fetching fraud cases:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFraudCases();
  }, []);

  const filteredCases = fraudCases.filter(fraudCase =>
    fraudCase.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    fraudCase.violation.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="tab-content">
      <h2>Fraud Alert List</h2>

      <div style={{ marginBottom: '30px' }}>
        <input
          type="text"
          placeholder="Search by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: '100%',
            padding: '12px',
            fontSize: '16px',
            border: '2px solid #e74c3c',
            borderRadius: '8px'
          }}
        />
      </div>

      {loading ? (
        <div style={{
          padding: '40px',
          textAlign: 'center',
          fontSize: '18px',
          color: '#666'
        }}>
          Loading fraud cases...
        </div>
      ) : (
        <div style={{ marginBottom: '30px' }}>
          <h3 style={{ color: '#e74c3c', marginBottom: '20px' }}>
            Reported Fraud Cases ({filteredCases.length})
          </h3>
          <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
            Click on any case to see detailed information
          </p>

          {filteredCases.length > 0 ? (
          <ul className="list-container">
            {filteredCases.map((fraudCase) => (
              <li key={fraudCase.caseId} className="list-item fraud-item">
                <div
                  className="item-name"
                  onClick={() => setSelectedCase(selectedCase === fraudCase.caseId ? null : fraudCase.caseId)}
                  style={{ cursor: 'pointer' }}
                >
                  ⚠️ {fraudCase.name}
                  <span style={{
                    marginLeft: '15px',
                    fontSize: '14px',
                    color: '#e74c3c',
                    fontWeight: 'normal'
                  }}>
                    - {fraudCase.violation}
                  </span>
                </div>

                <div className={`hover-details ${selectedCase === fraudCase.caseId ? 'active' : ''}`}>
                  <h3>⚠️ {fraudCase.name}</h3>

                  <div style={{ marginBottom: '15px' }}>
                    <p><strong>Case ID:</strong> {fraudCase.caseId}</p>
                    <p><strong>Status:</strong> <span style={{ color: '#f39c12' }}>{fraudCase.status}</span></p>
                    <p><strong>Warning Level:</strong> <span style={{ color: '#e74c3c', fontWeight: 'bold' }}>{fraudCase.warningLevel}</span></p>
                  </div>

                  <div style={{ marginBottom: '15px' }}>
                    <p><strong>Violation:</strong> {fraudCase.violation}</p>
                    <p><strong>Reported:</strong> {fraudCase.reported}</p>
                    <p><strong>Severity:</strong> <span style={{ color: '#e74c3c' }}>{fraudCase.severity}</span></p>
                  </div>

                  <div style={{ marginBottom: '15px' }}>
                    <p><strong>Total Complaints:</strong> {fraudCase.complaints}</p>
                    <p><strong>Victim Count:</strong> {fraudCase.victimCount}</p>
                    <p><strong>Estimated Loss:</strong> {fraudCase.estimatedLoss}</p>
                  </div>

                  <div style={{ marginBottom: '15px' }}>
                    <p><strong>Last Known Location:</strong> {fraudCase.lastKnownLocation}</p>
                    <p><strong>Known Aliases:</strong> {fraudCase.aliases}</p>
                  </div>

                  <div style={{ marginBottom: '15px', fontSize: '13px' }}>
                    <p><strong>Description:</strong></p>
                    <p style={{ marginTop: '5px' }}>{fraudCase.description}</p>
                  </div>

                  <div style={{
                    padding: '10px',
                    backgroundColor: '#ffcccc',
                    borderRadius: '5px',
                    border: '1px solid #e74c3c',
                    marginTop: '10px'
                  }}>
                    <p style={{ fontSize: '12px', fontWeight: 'bold', color: '#c0392b', margin: '0' }}>
                      🚨 WARNING: Do not engage with this entity
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p style={{ textAlign: 'center', color: '#888', fontSize: '16px' }}>
            No fraud cases found matching your search criteria.
          </p>
        )}
        </div>
      )}

    </div>
  );
}

export default Fraud;
